<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> AR Interest Invoice</h4>
						<p class="card-category text-right">Process AR Invoices</p>
					</div>
					
					<div class="card-body" style="overflow:scroll;max-height:100%">	
							<form [formGroup]="searchForm">
							<div class="row stickyrow">
								
								<div class="col-3">
									<div class="round-input">
										<span class="round-input__label">Cutoff Value</span>
										<div class="round-input__field">
											<button type="button" class="round-input__clear" (click)="searchForm.get('cutoffvalue').setValue(0)" aria-label="Clear amount">&times;</button>
											<input type="text" class="round-input__input" placeholder="0.00" aria-label="Cutoff" formControlName="cutoffvalue" inputmode="decimal" />
										</div>
									</div>
								</div>
								<div class="col-3">
								
										<mat-form-field class="round-input">
										<span class="round-input__label">Cutoff Date</span>
											<input class="round-input__input" matInput (click)="orderdatepicker.open()" formControlName="cutoffdate" [matDatepicker]="orderdatepicker">
											<mat-datepicker #orderdatepicker></mat-datepicker>			
										</mat-form-field>
										
								</div>
								<div class="col-3 v-center">
										<button class="btn btn-primary" (click)="refreshData()"><mat-icon>search</mat-icon>Refresh</button>
								</div>
								
								<div class="col-3 queue-right">
									<section class="queue-stats">
										<div class="stat stat-warn">
											<div class="stat-value">{{ getCount()}}</div>
											<div class="stat-label">Overdue Customers</div>
										</div>
										<div class="stat stat-ready">
											<div class="stat-value">{{ getTotal() | currency}}</div>
											<div class="stat-label">Total Amount To Charge</div>
										</div>
										
									</section>
								</div>
							</div>
							</form>
							<div class="row" *ngIf="!loading">
								<div class="col-8">
									<div class="round-input">
										<div class="round-input__field">
											<button type="button" class="round-input__clear" (click)="searchText.setValue('')" aria-label="Clear amount">&times;</button>
											<input type="text" class="round-input__input" placeholder="Filter Results" aria-label="Cutoff" [formControl]="searchText" />
										</div>
									</div>
								</div>
								<div class="col-4 v-center">
										<button class="btn btn-success" (click)="processInvoices()"><mat-icon>refresh</mat-icon>Process</button>
										&nbsp;
										<button class="btn btn-primary" (click)="flipSelection()"><mat-icon>swap_horiz</mat-icon>Flip Selection</button>								
								</div>
							</div>
							<div class="row" *ngIf="!loading">
							<div class="col-12">
							<p-accordion id="saleAcc" [(activeIndex)]="openAccordion" >
					<p-accordionTab *ngFor="let customer of filteredardata" [ngClass]="customer.selected ? 'selected': ''"> 
					<ng-template pTemplate="header">
						<div  class="header-row-container" style="width: 100%;">
							<div class="row">
								<div class="col-10">
								<h4>{{ customer.debtorno }} - {{ customer.debtorname }}</h4>
								</div>
								<div class="col-2 stat stat-ready" style="text-align: right;">
								<h4>{{ customer.totalcharge | currency }}</h4>
								</div>
							</div>
							<div class="row">
								<div class="col-10">
								 <table class="table">
								 <thead class="thead-dark">
								  <tr>
									<th>Balance</th>
									<th>Current</th>
									<th>Due</th>
									<th>30+ Days</th>
									<th>60+ Days</th>
									<th>90+ Days</th>
								  </tr>
								  </thead>
								  <tbody>
								  <tr>
								    <td>{{ customer.aged.balence | currency}}</td>
									<td>{{ customer.aged.current | currency}}</td>
									<td>{{ customer.aged.due | currency}}</td>
									<td>{{ customer.aged.overdue1 | currency}}</td>
									<td>{{ customer.aged.overdue2 | currency}}</td>
									<td>{{ customer.aged.overdue3 | currency}}</td>
								  </tr>
								  </tbody>
								 </table>
								</div>
								<div class="col-2" style="text-align: right;">
								 <mat-slide-toggle class="nav-link h-10" (click)="$event.stopPropagation()" [(ngModel)]="customer.selected">
								</mat-slide-toggle>
								</div>	
							</div>	
						</div>
					</ng-template>
					<table class="table table-striped">
					<tr><th>{{ config.documentlabel ? config.documentlabel : "Document" }} #</th><th>Date</th><th>Due Date</th><th>Terms</th><th>Age</th><th>Balance Due</th><th>Interest Rate</th><th>Amount Charged</th></tr>
					<tr *ngFor="let invoice of customer.invoices">
					<td> {{ invoice.transno }}</td>
					<td> {{ invoice.trandate }} </td>
					<td> {{ invoice.duedate }} </td>
					<td> {{ invoice.payterms }} </td>
					<td> {{ invoice.age }} </td>
					<td> {{ invoice.invoicebal | currency }}</td>
					<td> {{ invoice.arintrate * 100}}% </td>
					<td> {{ invoice.interest | currency }} </td>
					</tr>
					</table>
					</p-accordionTab>
					</p-accordion>
								</div>
							</div>
							<div *ngIf="loading">
							<svg class="spinner count-saving" width="55px" height="55px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                            </svg>
							</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>